import React, { useEffect, useState } from 'react'
import UnitCountTwo from './child/UnitCountTwo'
import RevenueGrowthOne from './child/RevenueGrowthOne'
import EarningStaticOne from './child/EarningStaticOne'
import CustomerOverview from './child/CustomerOverview'
import ClientPaymentOne from './child/ClientPaymentOne'
import CountryStatusOne from './child/CountryStatusOne'
import RevenueHistorySection from './dashboard/RevenueHistorySection'
import LatestPerformanceOne from './child/LatestPerformanceOne'
import LastTransactionOne from './child/LastTransactionOne'
import LeadsOverview from './graphs/LeadsOverview'
import TicketOverview from './graphs/TicketOverview'
import CommonLoader from './loaders/CommonLoader'
import useAdminsApi from '../api/useAdminsApi'

const DashBoardLayerTwo = ({ states, loading }) => {
  const { getProfile } = useAdminsApi();
  const [data, setData] = useState(null);

  useEffect(() => {
    async function fetchProfile() {
      const res = await getProfile();
      const profile = res.data.payload;
      setData(profile)
    }
    fetchProfile();
  }, [])

  return (
    <section className="row gy-4">
      {(states === null && loading) ?
        <div>
          <CommonLoader />
        </div>
        :
        <>
          <UnitCountTwo states={states} />

          {/* <RevenueGrowthOne /> */}

          <EarningStaticOne states={states} />

          <LeadsOverview states={states} />
          <TicketOverview states={states} />
        </>
      }

      {data?.user_type === "superadmin" && <RevenueHistorySection />}

    </section>

  )
}

export default DashBoardLayerTwo